import { IndexAllocation as OldIndexAllocation } from "@models/tradable/index-allocation";

export interface IndexAllocation {
	readonly assetId: string;
	readonly balance: number;
	readonly allocation: string;
	readonly allocationPercentage: string;
}

export class IndexAllocationAdapter {
	public adapt(indexAllocation: OldIndexAllocation): IndexAllocation {
		return {
			assetId: indexAllocation.getAssetId(),
			balance: +indexAllocation.getBalance(),
			allocation: indexAllocation.getAllocation(),
			allocationPercentage: indexAllocation.getAllocationPercent()
		};
	}

	public adaptMany(indexAllocations: OldIndexAllocation[]): IndexAllocation[] {
		return indexAllocations.map((ia) => this.adapt(ia));
	}
}
